module.exports = __webpack_public_path__ + "img/aftersell-cn.25c5cb31.png";